import React from 'react';
import { useOutletContext } from 'react-router-dom';

interface ReportCreationContextProps {
  Component: React.ComponentType<any>
}

interface WizardContext {
  data: any;
  updateData: (data: any) => void;
  stepErrors: Record<string, string>;
}

export const ReportCreationContext: React.FC<ReportCreationContextProps> = ({
  Component
}) => {
  const { data, updateData, stepErrors } = useOutletContext<WizardContext>();
  return (
    <Component
      data={data}
      updateData={updateData}
      stepErrors={stepErrors}
    />
  );
};
